import { HttpClient } from '@angular/common/http';
import { FOLDER_HEADER_NAME } from '@services/generics/constants';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var PermissionsService = /** @class */ (function () {
    function PermissionsService(_http) {
        this._http = _http;
        this._endpoint = '/odata/Users/UiPath.Server.Configuration.OData.GetCurrentPermissions';
    }
    PermissionsService.prototype.get = function (folderId) {
        var headers = {};
        if (folderId != null) {
            headers[FOLDER_HEADER_NAME] = folderId.toString();
        }
        return this._http.get(this._endpoint, { headers: headers })
            .pipe(map(function (_a) {
            var Permissions = _a.Permissions;
            return Permissions;
        }));
    };
    PermissionsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PermissionsService_Factory() { return new PermissionsService(i0.ɵɵinject(i1.HttpClient)); }, token: PermissionsService, providedIn: "root" });
    return PermissionsService;
}());
export { PermissionsService };
